const Loader = () => {
    return (
        <div className="bouncer fixed top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}

export default Loader;
